<template>
    <el-container>
        <fhead></fhead>
        <el-main >
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.generators')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.generators')}} <span style="color: rgb(144, 147, 153);">（top 30）</span></span>
                </div>
                <el-table class="center"
                          v-loading="GeneratorsLoading"
                          stripe
                          :data="GeneratorsData"
                          style="width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table
                                    :data="scope.row.lessors"
                                    border
                                    style="width: 560px">
                                <el-table-column
                                        :label="$t('l.lessorRS')"
                                        width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.lessorRS">
                                            <el-button type="text"> {{scope.row.lessorRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        :label="$t('l.guaranteedBalanceNQT')"
                                >
                                    <template slot-scope="scope">
                                        {{$g.wallet.amount(scope.row.guaranteedBalanceNQT)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="id"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="accountRS"
                            :label="$t('l.accountRS')"
                            width="360">
                        <template slot-scope="scope">
                            <router-link :to="'/account/'+scope.row.accountRS">
                                <el-button type="text"> {{scope.row.accountRS}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="effectiveBalance"
                            :label="$t('l.effectiveBalance')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="sum"
                            :label="$t('l.lessorSum')"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.lessorTimes')"
                            width="180">
                        <template slot-scope="scope">
                            {{$g.wallet.formatDateTime(scope.row.hitTime,($store.state.epochBeginning-500))}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="deadline"
                            :label="$t('l.deadline')"
                    >
                    </el-table-column>
                </el-table>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from './fhead.vue';
    var load;

    export default {
        name: 'generators',
        components: {
            fhead
        },
        data () {
            return {
                GeneratorsLoading:true,
                GeneratorsData:[],
                sum:0
            }
        },
        methods: {
            Lessors(item){
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccountLessors&account='+item.accountRS,
                }).then(response=>{
                    this.sum--;
                    item.lessors=response.lessors;
                    item.lessors.forEach(v=>{
                        v=this.$g.wallet.lessors(v,this.$store.state.apiText)
                    })
                    item.sum=response.lessors.length;
                    if(this.sum==0){
                        this.GeneratorsData=JSON.parse(JSON.stringify(this.GeneratorsData))
                    }
                })
            },
            Generators(){
                this.GeneratorsLoading=true;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getNextBlockGenerators&limit=30',
                }).then(response => {
                    this.GeneratorsLoading=false;
                    this.total=response.activeCount;
                    this.GeneratorsData=response.generators;
                    this.sum=this.GeneratorsData.length;
                    this.GeneratorsData.forEach(item=>{
                        this.Lessors(item);
                        item=this.$g.wallet.effectiveBalance(item,this.$store.state.apiText);
                        item.deadline=this.$g.wallet.timeDiff(
                            this.$g.wallet.formatDateTime(
                                item.hitTime,(this.$store.state.epochBeginning-500)
                            )
                        );
                    })
                });
            }
        },
        created: function () {
            load =setInterval(()=>{
                if(this.$store.state.epochBeginning!=''){
                    this.Generators();
                    window.clearInterval(load)
                }
            },2000);

        },
    }
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/generators.vue